module.exports = __webpack_public_path__ + "media/images/application/avatar-70a66ab1a02b277d85c1e45bbc1a8812.png";